import { FieldHookConfig, useField } from 'formik';
import { Props } from './types';

function InputUploadFile({ inputFileRef, ...props }: Props) {
  const [field, {}, helpers] = useField(props as FieldHookConfig<any>);

  return (
    <input
      {...field}
      {...props}
      type="file"
      value={undefined}
      id={props.name}
      ref={inputFileRef}
      onChange={(event) => {
        if (event.target.files.length > 0) {
          helpers.setTouched(true);
          helpers.setValue(event.target.files[0]);
        }
      }}
    />
  );
}

export default InputUploadFile;
